import type { Ref } from 'react';
import { InputAdornment, TextField } from '@mui/material';
import Search from '@mui/icons-material/Search';

export interface SearchInputProps {
  /** Controlled value. */
  value: string;
  /** Fired with the new query string on each keystroke. */
  onChange: (value: string) => void;
  /** Placeholder (translated copy). */
  placeholder?: string;
  /** Accessible label (translated copy). */
  ariaLabel?: string;
  /** Field width. */
  width?: number | string;
  ref?: Ref<HTMLInputElement>;
}

/**
 * Search box with a leading magnifier. A thin controlled wrapper over MUI
 * `TextField`; debouncing is the caller's concern.
 */
export function SearchInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
  width = 240,
  ref,
}: SearchInputProps) {
  return (
    <TextField
      inputRef={ref}
      size="small"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      sx={{ width }}
      slotProps={{
        htmlInput: { 'aria-label': ariaLabel },
        input: {
          startAdornment: (
            <InputAdornment position="start">
              <Search sx={{ fontSize: 14, color: 'text.secondary' }} />
            </InputAdornment>
          ),
        },
      }}
    />
  );
}
